import localScaleManager from "../../../helpers/LocalScaleManager";
export default class TableLoading {
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    this.overlay = this.scene.add.rectangle(0, 0, 0, 0, 0x000000);
    this.overlay.setAlpha(0.5);
    this.overlay.setDepth(500).setVisible(false);
    this.table.poolArray.push(this.overlay);

    this.loadingImg = this.scene.add
      .image(0, 0, "loading")
      .setDepth(this.overlay.depth + 1)
      .setVisible(false);
    this.table.poolArray.push(this.loadingImg);

    this.loadingTween = this.scene.tweens.add({
      targets: this.loadingImg,
      ease: "Quad.easeIn",
      duration: 650,
      scaleX: 0,
      flipX: true,
      yoyo: true,
      loop: -1,
      paused: true,
    });
  }
  show() {
    this.loadingTween.play();
    this.scene.changeObjectsInteractivity(false);
    if (!this.loadingImg.visible) this.loadingImg.setVisible(true);
    if (!this.overlay.visible) this.overlay.setVisible(true);
  }
  hide() {
    this.scene.changeObjectsInteractivity(true);
    if (this.loadingImg.visible) this.loadingImg.setVisible(false);
    if (this.overlay.visible) this.overlay.setVisible(false);
    this.loadingTween.pause();
  }
  /**
   * @param {number} tableIndex
   * @param {number} height
   * @param {number} width
   * @param {number} initX
   * @param {number} initY
   */
  positionControls(tableIndex, width, height, initX, initY) {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    // const visitedTableGameIndex = this.scene.getVisitedTableGameIndex();
    // if(visitedTableGameIndex !== -1)
    this.overlay.setPosition(tableIndex * this.overlay.width, 0);
    // else this.overlay.setPosition(0 , 0)
    // this.overlay.setPosition(this.scene.gameWidth / 2, this.scene.gameHeight / 2)
    const bgSize = width * 2;
    localScaleManager.scaleSprite(
      this.loadingImg,
      bgSize / 6,
      bgSize / 6,
      0,
      1,
      true
    );
    this.loadingImg.setPosition(initX + width / 2, initY + height / 2);
  }
  /**
   * @param {number} tableIndex
   * @param {number} height
   * @param {number} width
   * @param {number} initX
   * @param {number} initY
   */
  reposition(tableIndex, width, height, initX, initY) {
    this.overlay.width = this.scene.gameWidth;
    this.overlay.height = this.scene.gameHeight;
    this.overlay.setPosition(tableIndex * this.overlay.width, 0);
    this.loadingImg.setPosition(initX + width / 2, initY + height / 2);
  }
}
